import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { clearAllDrafts } from "@/lib/safeSave";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=logged in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
    const onExpired = () => setUser(false);
    window.addEventListener("csp:session-expired", onExpired);
    return () => window.removeEventListener("csp:session-expired", onExpired);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("csp_token");
    clearAllDrafts(); // logout volontario: nessuna bozza resta sul dispositivo
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout }}>{children}</AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
